import { IContainer } from '../../common/container/IContainer';
import { ILocalizationToken } from './ILocalization';
import { createTranslation } from './Translation';

export async function languageContainer(container: IContainer): Promise<IContainer> {
  container.setByToken(ILocalizationToken, await createTranslation());
  return container;
}
